import React from "react";
import MetricSummaryTile from "../../../../ui-components/metric-summary-tile/metricSummaryTile";
import { DenimUploadBatchStatus, FactoringStats } from "../../../../app/data/invoice-factoring/models";

export interface BatchesSummaryTilesProps {
  stats?: FactoringStats;
  isLoading: boolean;
  onStatusFilter: (status: DenimUploadBatchStatus) => void;
  onOpenInvoicesNeedingAttention: () => void;
}

const BatchesSummaryTiles: React.FC<BatchesSummaryTilesProps> = ({
  stats,
  isLoading,
  onStatusFilter,
  onOpenInvoicesNeedingAttention,
}) => {
  const byStatus = stats?.byStatus;
  const needsReview = (byStatus?.COMPLETED_WITH_ERRORS ?? 0) + (byStatus?.FAILED ?? 0);

  return (
    <div className="xgs-invoice-factoring__summary">
      <MetricSummaryTile
        iconPreset="fileBlue"
        colorVariant="blue"
        isLoading={isLoading}
        title="Sending now"
        value={stats?.active ?? 0}
        legendDescription="Batches that are queued, sending, or stopping after the current invoice."
        onApply={() => onStatusFilter("RUNNING")}
      />
      <MetricSummaryTile
        iconPreset="filePurplePending"
        colorVariant="purple"
        isLoading={isLoading}
        title="Not started"
        value={byStatus?.DRAFT ?? 0}
        legendDescription="Uploaded batches waiting for an administrator to start sending."
        onApply={() => onStatusFilter("DRAFT")}
      />
      <MetricSummaryTile
        iconPreset="exclamationRed"
        colorVariant="red"
        isLoading={isLoading}
        title="Needs review"
        value={needsReview}
        legendDescription="Batches that finished with failed invoices or stopped because of an error."
        onApply={() => onStatusFilter("COMPLETED_WITH_ERRORS")}
      />
      <MetricSummaryTile
        iconPreset="clockYellow"
        colorVariant="yellow"
        isLoading={isLoading}
        title="Invoices needing attention"
        value={stats?.invoicesNeedingAttention ?? 0}
        legendDescription="Factored invoices with no proof of delivery, a duplicate on Denim, or another blocker."
        onApply={onOpenInvoicesNeedingAttention}
      />
      <MetricSummaryTile
        iconPreset="fileGreenCheck"
        colorVariant="green"
        isLoading={isLoading}
        title="Tracked invoices"
        value={stats?.trackedInvoices ?? 0}
        legendDescription="Invoices OneXGS has tracked for factoring across all batches."
      />
    </div>
  );
};

export default BatchesSummaryTiles;
